<template>
  <div class="vip-container">
    <img :src="info.background" @click="showPayHandle">
    <!-- <button v-if="!isEffective">{{ message }}</button>
    <button v-else-if="available" @click="showPayHandle">快&nbsp;抢&nbsp;!&nbsp;!</button>
    <button v-else class="isReceive">已购买</button> -->
    <PayPopup ref="pay" :info="info" :type="3" @paynoready="getOpenid" @nologin="toLogin" />
    <KeepPopup ref="keep" @leave="leaveHandle" @stay="stayHandle" />
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui'
import { umtrack } from '@/utils/uweb'
import KeepPopup from '@/views/components/KeepPopup'
import PayPopup from '@/components/play'
import { vip } from '@/api/vip'
export default {
  name: 'Vip',
  components: {
    KeepPopup, PayPopup
  },
  data () {
    return {
      available: true,
      info: {},
      payMethod: 1,
      showPayInfo: false,
      isEffective: true,
      message: '',
      isLogin: true
    }
  },
  created () {
    // 监听返回键
    if (window.history && window.history.pushState) {
      if(!window.history.state || !window.history.state.hasOwnProperty('status') || window.history.state.status != 1) {
        history.pushState({ status: 1 }, null, document.URL);
      }
      window.addEventListener('popstate', this.keepStay, false);//false阻止默认事件
    }

    var query = this.$route.query
    this.code = query.code
    this.init()
    umtrack('vipview', {code: this.code, title: 'VIP'}, this)
  },
  mounted() {
    window.addEventListener('pageshow', (e)=>{
      if(e.persisted){
        window.location.reload()
      }
    })
  },
  methods: {
    init() {
      this.isEffective = true
      vip({code: this.code}).then((response)=>{
        this.info = response.data.data
        this.available = this.info.available
      }).catch((err)=>{
        this.isEffective = false
        this.info = err.data
        this.available = this.info.available
        var code = parseInt(err.code)
        switch (code) {
          case 402:
            this.message = '活动即将开始'
            break;
          case 405:
            this.message = '已经购买'
            MessageBox.alert('恭喜你已购买，快去选看视频吧!!!').then(action => {
              this.$router.replace({path: '/'})
            })
            break;
          case 406:
            this.isEffective = true
            this.isLogin = false
            break;
          default:
            this.message = '活动已结束'
            break;
        }
      })
    },
    showPayHandle() {
      umtrack('vip-pay', {id: this.info.id, title: this.info.title}, this)
      if(!this.isLogin){
        this.toLogin()
      }
      this.$refs.pay.show()
    },
    keepStay(e) {
      this.$refs.keep.show()
    },
    leaveHandle() {
      this.removeListener()
      setTimeout(function(){
        history.back(-1)
      }, 200)
    },
    stayHandle() {
      this.removeListener()
    },
    getOpenid(data) {
      window.location.replace(data)
    },
    toLogin() {
      this.$router.push({path: '/login', query: { scene: 'login', redirect: this.$route.fullPath}})
    },
    removeListener() {
      window.removeEventListener('popstate', this.keepStay, false);//false阻止默认事件
    }
  },
  destroyed(){
    this.removeListener()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.vip-container{
    &>img{
        width: 100vw;
        height: 100vh;
        display:block
    }
    &>button{
        border:none;
        background: linear-gradient(#ffc62d, #fec52d);
        color: #C84112;
        font-size: 26px;
        position: absolute;
        bottom: 0;
        right: 50%;
        width: 90vw;
        margin-right: -45vw;
        margin-bottom: 16px;
        padding: 6px 0;
        border-radius: 19px;
        outline: none;
        font-weight: 600;
        box-shadow: 0 -4px 8px -4px #ff2a0070 inset, 0 7px 8px 4px #ffeda620 inset;
    }
    &>button.isReceive{
      background-color: rgb(255, 221, 126);
      color: rgb(211, 117, 85);
      border: none;
    }
}
</style>
